import Vue from 'vue'
import Router from 'vue-router'
import maOtpView from '@/views/otp'
import maTimedoutView from '@/views/timedout'
import maErrorView from '@/views/error'
import maFnolFlow from '@/views/fnolFlow'
import { claimRouter } from '@/modules/Claim'
import { damageRouter } from '@/modules/Damage'
import { appointmentRouter } from '@/modules/Appointment'
import { documentRouter } from '@/modules/Document'

/**
 * @module
 * @name Router
 */

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    ...claimRouter,
    ...damageRouter,
    ...appointmentRouter,
    ...documentRouter,
    {
      path: '/otp',
      name: 'otp',
      component: maOtpView
    },
    {
      path: '/timedout',
      name: 'timedout',
      component: maTimedoutView
    },
    {
      path: '/error',
      name: 'error',
      component: maErrorView
    },
    {
      path: '/fnol-flow/:user/:sinisterId/:warrantyId',
      name: 'fnol-flow',
      component: maFnolFlow
    },
    {
      path: '/scencrypt/:scencryptId',
      name: 'scencrypt'
    },
    {
      path: '/selfcareInit',
      name: 'initialPath'
    },
    {
      path: '*',
      redirect: 'error'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: -6 }
  }
})
router.navigationHistory = []

router.beforeEach((to, from, next) => {
  if (from && from.name) {
    router.navigationHistory.push(from.name)
  }

  next()
})

export default router
